import manifests from '~/sagas/manifests/manifests.saga';

export default manifests;
